(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.Applications.EApps",
                {
                    url: "/EApps",
                    component: "eapplications",
                    PageTitle: "E-Applications"

                });
        }
    ]);

    app.component("eapplications",
        {
            templateUrl: "App/Tools/Applications/eApps/eApps.html",
            controller: "eAppsCtrl"
        });


    app.controller("eAppsCtrl", ["$scope", "ssoApi", "$http", "permissionService", "externalLoading", "iComplyApi", "iComplySettings", function ($scope, ssoApi, $http, permissionService, externalLoading, iComplyApi, iComplySettings) {
        var $ctrl = this;

        ng.extend($ctrl, {
            ui: {
                darkTheme: localStorage.getItem('darkTheme') === 'true' ? true : false
            }
        });
        $scope.$on('themeUpdated', function (event, value) {
            $ctrl.ui.darkTheme = value;
        });
        this.ActivateFirelightSso = function () {
            if (permissionService.hasOnePermission("Firelight:Access")) {
                //console.log(this.SamlData);
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateFirelightSso(this.SamlData).then(function (data) {
                    w.document.write(data);
                    w.document.forms.samlform.submit();
                },
                    function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        };

        this.ActivateIpipelineSso = function () {
            if (permissionService.hasOnePermission("IpipelineEApps:Access")) {
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateIpipelineEappsSso().then(function (data) {
                    //console.log(data);          
                    w.document.write(data);
                    w.document.forms.samlform.submit();
                },
                    function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        }
    }]);

})(window.app, window.angular); // jshint ignore:line